<template>
  <Layout
    v-if="course && $store.state.general.currentUserAccountDetails?.featureFlags?.new_agent_training_course"
    :course="course"
    :course-section="courseSection"
    :lecture="lecture"
  >
    <div className="rounded overflow-hidden w-full max-w-4xl mx-auto shadow-lg">
      <iframe
        class="w-full"
        height="525"
        :src="lecture.material_url"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex';
import Layout from '../components/LmsLayout/index.vue';

export default {
  components: {
    Layout,
  },
  data() {
    return {
      userId: null,
      courseData: {
        course: null,
      },
    };
  },
  computed: {
    ...mapState({
      user: state => state.general.currentUser,
      currentUserAccountDetails: state => state.general.currentUserAccountDetails,
    }),
    course() {
      return this.courseData?.course;
    },
    lectures() {
      return this.courseData.course.course_sections.map(cs => cs.lectures).flat();
    },
    courseSection() {
      return this.courseData.course.course_sections.find(cs => {
        const lecture = cs.lectures.find(l => l.id === parseInt(this.$route.params.id));
        return !!lecture;
      });
    },
    lecture() {
      return this.lectures.find(l => l.id === parseInt(this.$route.params.id));
    },
  },
  async mounted() {
    if (this.currentUserAccountDetails.role !== 'Agent') {
      await this.$router.push('/');
    }

    await Promise.all([this.$store.dispatch('general/loadCurrentUser'), this.loadCourseData()]);
    const { id: userId } = this.user;
    this.userId = userId;
  },
  methods: {
    async loadCourseData() {
      const res = await fetch(`/api/agent_training_course`);
      const { course } = await res.json();
      this.courseData.course = course;
    },
  },
};
</script>
